export default {"src":"/_next/static/media/payment-tether-icon.c9080c38.svg","height":20,"width":28};